import { render, staticRenderFns } from "./VeStuHealthScore.vue?vue&type=template&id=8bbd18c0&scoped=true"
import script from "./VeStuHealthScore.vue?vue&type=script&lang=js"
export * from "./VeStuHealthScore.vue?vue&type=script&lang=js"
import style0 from "./VeStuHealthScore.vue?vue&type=style&index=0&id=8bbd18c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbd18c0",
  null
  
)

export default component.exports